import i18n from "i18next";

export const getCopyMessage = (name?: string) =>
  name
    ? i18n.t("common:copy.copied_name", { name })
    : i18n.t("common:copy.copied");
